// The V2 login's places (spec D3); the old login and its AUTH_V2 switch are gone (#0612).
// No imports here on purpose: store.js, axios.js and the router read this before anything else is loaded.
/** Where a logout or an expired session lands */
export const LOGIN_ROUTE_NAME = 'AuthLogin';
export const LOGIN_PATH = '/auth/login';
/** The logout call under the API base URL */
export const LOGOUT_API_PATH = '/session/logout';
/** The session read (GET) under the API base URL: its 401 only says "no login", authFlow handles it */
export const SESSION_API_PATH = '/session';
